import { BaseApiModel } from './BaseApiModel';

export class Violation extends BaseApiModel {
  public passId: string;
  public contractId: string;
  public laneCode: string;
  public laneNumber: number;
  public laneClientCode: string;
  public lotId: string;
  public lotIdAudit: string;
  public regulationId: string;
  public spotCode: string;
  public date: Date;
  public speedLimit: number;
  public calculatedSpeed: number;
  public speed: number;
  public speedWarning: boolean;
  public redLightPeriod: number;
  public stopPeriod: number;
  public equipmentViolationCounter: number;
  public address: {
    street: string;
    // eslint-disable-next-line id-blacklist
    number: number;
    zipCode: string;
    isKm: boolean;
    landMark: string;
  };
  public gracePeriod: number;
  public vehicle: {
    length: number;
    profile: number;
    size: number;
    plate: string;
    plateOCR: string;
    brandModelCode: string;
    brandModel: string;
    colorCode: string;
    classificationCode: string;
    categoryCode: string;
    typeCode: string;
    cityCode: string;
    year: number;
    modelYear: number;
    chassis: string;
    renavam: number;
    speed: number;
    weight: number;
    uf: string;
    abbreviation: string;
    color: string;
    stateId: number;
    regionId: number;
    regionCode: string;
    foreignPlate: boolean;
    weighClassCode: string;
    category: string;
    city: string;
    type: string;
    weightClassCode: string;
    weigthClassCode: string;
  };
  public files: Array<{
    // eslint-disable-next-line no-use-before-define
    type: FileType;
    targeHeight: number;
    targePosition: string;
    urlCurrent: string;
    urlEncrypted: string;
    urlDecrypted: string;
  }>;
  public equipment: {
    id: string;
    serialNumber: string;
    manufacturerId: string;
    model: string;
    modelName: string;
    calibration: {
      id: string;
      appraisalNumber: string;
      date: Date;
      type: string;
    };
  };
  public reason: {
    code: string;
    name: string;
    type: string;
  };
  public linkedParent: string;
  public linkedChild: string;
  public notes: Array<{
    userId: string;
    dateTime: Date;
    comment: string;
  }>;
  public quarantineReason: string;
  public status: string;
  public step: string;
  public history: {
    triage: Array<{
      authorId: number;
      date: Date;
      authorName: string;
      registryNumber: {
        type: string;
      };
    }>;
    typing: Array<{
      authorId: number;
      date: Date;
      authorName: string;
      registryNumber: string;
    }>;
    doubleTyping: Array<{
      authorId: number;
      date: string;
      authorName: string;
      registryNumber: string;
    }>;
    verifyValid: Array<{
      authorId: number;
      date: Date;
      authorName: string;
      registryNumber: string;
    }>;
    verifyInvalid: Array<{
      authorId: number;
      date: Date;
      authorName: string;
      registryNumber: string;
    }>;
    validate: Array<{
      authorId: number;
      date: Date;
      authorName: string;
      registryNumber: string;
    }>;
    lotAttribution: {
      authorId: number;
      date: Date;
      authorName: string;
      registryNumber: string;
    };
    audits: Array<{
      authorId: number;
      date: Date;
      authorName: string;
      registryNumber: string;
      lotRevision: string;
    }>;
    revisions: Array<{
      authorId: number;
      date: Date;
      authorName: string;
      registryNumber: string;
      lotRevision: string;
    }>;
  };
  public lockUserId: number;
  public lockDate: Date;
  public createdAt: Date;
  public modifiedAt: Date;
  public extraData: any;
  public exemptPeriodId: string;
  public vehicleWhiteListId: string;
  public auditAuthorId: number;
  public timezone: string;
  public typingAuthorId: number;
  public Histories: Array<{
    id: number;
    violationId: number;
    step: string;
    authorId: number;
    authorName: string;
    registryNumber: string;
    date: Date;
  }>;
}

// eslint-disable-next-line no-shadow
export enum FileType {
  pan = 'pan',
  pan2 = 'pan2',
  zoom = 'zoom',
  video = 'video',
  video2 = 'video2',
  additional = 'additional',
  additional2 = 'additional2'
}
